<template>
    <div class="risk-assessment-form row position-relative">
        <div class="loaders--container" v-if="saving">
            <div class="loaders--standard"></div>
        </div>

        <risk-assessment-modal
            :company-style="companyStyle"
            ref="riskAssessmentModal"
        ></risk-assessment-modal>

        <div class="col-12 col-sm-6">
            <div class="form-group">
                <label for="risk" class="form-label">Risk</label>
                <input type="text" class="form-control" id="risk" placeholder="Enter Risk" v-model="riskData.title">
            </div>
        </div>

        <div class="col-12 col-sm-6">
            <div class="form-group">
                <search-or-create-model
                    v-model="riskData.category"

                    :label-above="true"
                    label="Category"
                    label-class="form-label"
                    :search_url="categoryUrl"

                    :errors="[]"
                    model_name="category"

                    :selected="category_selected"
                    @select_model="category_selected = true"
                    @unselect_model="category_selected = false"
                ></search-or-create-model>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <label class="form-title risk-assessment--title">Risk Assessment</label>

                <div class="risks">
                    <table class="table table-responsive risk-assessment__table">
                        <tbody>
                            <tr class="risk-assessment__table--row"  v-for="(assessment, key) in riskData.assessments">
                                <td class="risk-assessment__table--cell">
                                    <label class="form-label">Specific Hazards / Risks</label>
                                    <textarea rows="3" class="form-control" v-model="riskData.assessments[key].hazard"></textarea>
                                </td>
                                <td class="risk-assessment__table--cell">
                                    <label class="form-label">People are at risk from what</label>
                                    <textarea rows="3" class="form-control" v-model="riskData.assessments[key].at_risk_from"></textarea>
                                </td>
                                <td class="risk-assessment__table--cell">
                                    <label class="form-label">Evaluate Existing controls</label>
                                    <textarea rows="3" class="form-control" v-model="riskData.assessments[key].existing_controls"></textarea>
                                </td>
                                <td class="risk-assessment__table--cell">
                                    <label class="form-label">Risk Factor Likelihood x Severity</label>
                                    <div class="p-2 d-flex align-items-center risk-assessment__risk-values" :class="riskBackground(riskData.assessments[key].risk_factor, riskData.assessments[key].severity)">
                                        <input class="form-control risk-assessment__risk-values--input" type="number" min="1" max="5" v-model="riskData.assessments[key].risk_factor">
                                        <span>x</span>
                                        <input class="form-control risk-assessment__risk-values--input" type="number" min="1" max="5" v-model="riskData.assessments[key].severity">
                                        <span>=</span>
                                        <input class="form-control risk-assessment__risk-values--input" :value="riskTotal(riskData.assessments[key].risk_factor, riskData.assessments[key].severity)">

                                        <svg-image
                                            :src="'/svg/' + resource_group + '/info.svg'"
                                            width="20px"
                                            height="25px"
                                            color="white"
                                            highlight="primary"
                                            class="risk-assessment__risk-values--info-button"

                                            @click="openRiskModal"
                                        ></svg-image>
                                    </div>
                                </td>
                                <td class="risk-assessment__table--cell">
                                    <label class="form-label">Evaluate any further controls or information</label>
                                    <textarea rows="3" class="form-control" v-model="riskData.assessments[key].further_controls"></textarea>
                                </td>
                                <td class="risk-assessment__table--cell">
                                    <label class="form-label">Risk Factor after controls</label>
                                    <div class="p-2 d-flex align-items-center risk-assessment__risk-values" :class="riskBackground(riskData.assessments[key].risk_factor_after_controls, riskData.assessments[key].severity_after_controls)">
                                        <input class="form-control risk-assessment__risk-values--input" type="number" min="1" max="5" v-model="riskData.assessments[key].risk_factor_after_controls">
                                        <span>x</span>
                                        <input class="form-control risk-assessment__risk-values--input" type="number" min="1" max="5" v-model="riskData.assessments[key].severity_after_controls">
                                        <span>=</span>
                                        <input class="form-control risk-assessment__risk-values--input" :value="riskTotal(riskData.assessments[key].risk_factor_after_controls, riskData.assessments[key].severity_after_controls)">

                                        <svg-image
                                            :src="'/svg/' + resource_group + '/info.svg'"
                                            width="20px"
                                            height="25px"
                                            color="white"
                                            highlight="primary"
                                            class="risk-assessment__risk-values--info-button"

                                            @click="openRiskModal"
                                        ></svg-image>
                                    </div>
                                </td>
                                <td class="risk-assessment__table--cell">
                                    <label class="form-label">Action By</label>
                                    <select class="form-control" v-model="riskData.assessments[key].action_by">
                                        <option>Supervisor</option>
                                        <option>Principle Contractor</option>
                                        <option>Supervisor and Principal Contractor</option>
                                    </select>
                                </td>
                                <td class="risk-assessment__table--cell">
                                    <label class="form-label">Action At</label>
                                    <select class="form-control" v-model="riskData.assessments[key].action_at">
                                        <option>Daily</option>
                                        <option>Weekly</option>
                                        <option>Fortnightly</option>
                                        <option>Monthly</option>
                                        <option>Quarterly</option>
                                    </select>
                                </td>
                                <td class="risk-assessment__table--cell">
                                    <label class="form-label">&nbsp;</label>
                                    <a class="ml-2" @click="deleteAssessment(key)">
                                        <img :src="`/svg/${companyStyle}/bin.svg`">
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <button class="btn btn-primary" @click="addNewAssessment()">Add row</button>
                </div>
            </div>
        </div>

        <div class="col-12 text-right">
            <button @click="save()" class="btn btn-primary">Save</button>
        </div>
    </div>
</template>

<script>
    import SearchOrCreateModel from "../../general_components/SearchOrCreateModel";
    import RiskAssessmentModal from "../../modals/RiskAssessmentModal";

    export default {
        name: "RiskCreateEditPage",

        components: {SearchOrCreateModel, RiskAssessmentModal},

        props: {
            method: {
                type: String,
                default: 'post'
            },
            submitUrl: {
                type: String,
                required: true
            },
            risk: {
                type: Object,
                default: () => { return {} }
            },

            categoryUrl: {
                type: String,
                required: true
            },
            deleteAssessmentUrl: {
                type: String,
                required: true
            },

            companyStyle: {
                type: String,
                required: true
            },
            backUrl: {
                type: String,
                required: true,
            }
        },

        data(){
            return {
                riskData: {
                    title: '',
                    category: {
                        name: ''
                    },
                    assessments: []
                },

                category_selected: false,
                saving: false,
                errors: []
            }
        },

        beforeMount() {
            window.addEventListener('LAYOUT:primary_button', this.save);
            window.addEventListener('LAYOUT:cancel_button', this.cancel);

            this.riskData = {...this.riskData, ...this.risk};

            this.category_selected = this.riskData.category.id !== undefined ? this.riskData.category.id : false;

            if(this.riskData.id == undefined){
                this.addNewAssessment();
            }
        },

        methods: {

            openRiskModal: function(e){
                this.$refs.riskAssessmentModal.open(e);
            },

            addNewAssessment: function(){
                let length = this.riskData.assessments.push({
                    hazard: '',
                    at_risk_from : '',
                    existing_controls: '',
                    risk_factor: '',
                    severity: '',
                    further_controls: '',
                    risk_factor_after_controls: '',
                    severity_after_controls: '',
                    action_by: '',
                    action_at: ''
                });
            },

            deleteAssessment: function(index){
                let item = this.riskData.assessments[index];

                if(item.id !== undefined){
                    axios.delete(this.deleteAssessmentUrl.replace('?', item.id))
                        .then((response) => {
                            this.riskData.assessments.splice(index, 1);

                            Vue.$toast.open({
                                message: 'Risk Assessment Deleted',
                                type: 'success'
                            });
                        });

                    return;
                }

                this.riskData.assessments.splice(index, 1);
                Vue.$toast.open({
                    message: 'Risk Assessment Deleted',
                    type: 'success'
                });
            },

            riskBackground: function(riskFactor, likelihood){
                const info = {
                    4: 'risk-assessment__risk-values--acceptable',
                    8: 'risk-assessment__risk-values--adequate',
                    12: 'risk-assessment__risk-values--tolerable',
                    25: 'risk-assessment__risk-values--unacceptable'
                }

                let value = parseInt(riskFactor) * parseInt(likelihood);
                    value = isNaN(value) ? 0 : value;

                let infoIndex = -1;

                Object.keys(info).some((index) => {
                    if(value <= index || index == 25){
                        infoIndex = index;
                        return true;
                    }
                });

                return info[infoIndex];
            },

            riskTotal: function(riskFactor, likelihood){
                let value = parseInt(riskFactor) * parseInt(likelihood);
                return isNaN(value) ? 0 : value;
            },

            save: function(){
                this.errors = [];

                if (this.saving){
					return false;
                }

				this.saving = true;

                axios({
                    method: this.method,
                    url: this.submitUrl,
                    data: this.riskData
                }).then((response) => {
                    this.saving = false;
                    window.location.href = response.data.url;
                }).catch((error) => {
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }

                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }

                    this.saving = false;
                });
            },

            cancel: function(){
                window.location.href = this.backUrl;
            },
        }
    }
</script>
